import { call, put } from 'redux-saga/effects'

import { toasts } from 'utils/toasts'

import { IndustryCertificateService } from '../../services'

import * as actions from './industryCertificate.actions'

export function* fetchAll(action) {
  const { params, companyId } = action.payload
  yield put(actions.setCertificate({ certificate: {} }))

  const $certificate = new IndustryCertificateService()
  const {
    success,
    status,
    data: certificates
  } = yield call($certificate.fetchAll.bind($certificate), {
    params,
    companyId
  })

  if (status === 404) {
    return yield put(
      actions.setCertificates({
        certificates: { items: [], pagination: { totalItems: 0 } }
      })
    )
  } else if (success) {
    yield put(actions.setCertificates({ certificates }))
  } else {
    toasts.generalFail()
  }
}

export function* fetchOne(action) {
  const { id } = action.payload

  yield put(actions.setLoading({ loading: true }))

  const $certificate = new IndustryCertificateService()
  const certificate = yield call($certificate.fetchOne.bind($certificate), id)

  if (certificate.success) {
    return yield put(
      actions.setCertificate({
        certificate: certificate.data
      })
    )
  } else toasts.generalFail()

  yield put(actions.setLoading({ loading: false }))
}
